/**
 * Created by PanJiaChen on 16/11/18.
 */
import { CHANNEL_ID, SERVER_BASE_URL } from '@/config'
import store from '@/store'
import md5 from 'js-md5'
import router from '@/router'
import moment from 'moment'
import $ from 'jquery'
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    //  Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    //  less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * @param {string}
 * @returns {Boolean}
 * 判断是否为空
 */
export function isEmpty(s) {
  if (s === undefined) {
    return true
  } else {
    if (
      s === null ||
      s === '' ||
      s === 'undefined' ||
      s === 'null' ||
      s === 'NULL' ||
      s.length < 1
    ) {
      return true
    }
  }
  return false
}
// 获取href参数
export function getUrlParam(val) {
  var uri = window.location.search || ''
  var re = new RegExp('' + val + '=([^&?]*)', 'ig')
  return uri.match(re) ? uri.match(re)[0].substr(val.length + 1) : null
}
// 页面跳转
export function jumpToNEwPage(pageName) {
  router.push({
    name: pageName
  })
}

/*
 *  输入金额验证
 * 保证输入框输入的为数字 e.g. <input type="text" onkeyup="validateNum(this, 9, 6)" />
 * precision：总位数（不含小数点），为空或0时不限位数 e.g. <input type="text"
 * onkeyup="validateNum(this)" /> scale：小数位数，为空或0时表示要求输入整数 e.g. <input
 * type="text" onkeyup="validateNum(this, 9)" />
 * isOwe:true时为负数
 * max:最大值
 */
export function validateNum(newVal, precision, scale, isOwe, max) {
  var oValue = newVal.toString()
  if (oValue.charAt(0) === '-') {
    oValue = oValue.substring(1, oValue.length)
  }
  if (scale == null || scale === 0) {
    //  要求输入为整数
    oValue = oValue.replace(/[^\d]/g, '')
    if (precision != null && precision > 0) {
      //  限制整数位数
      oValue = oValue.replace(
        new RegExp('^(\\d{' + precision + '})\\d+', 'g'),
        '$1'
      )
    }
  } else {
    oValue = oValue.replace(/[^\d.]/g, '')
    oValue = oValue.replace(/^\./g, '')
    oValue = oValue.replace(/\.{2,}/g, '.')
    oValue = oValue
      .replace('.', '$#$')
      .replace(/\./g, '')
      .replace('$#$', '.')
    oValue = oValue.replace(
      new RegExp('^(\\d{' + (precision - scale) + '})\\d+', 'g'),
      '$1'
    )
    oValue = oValue.replace(
      new RegExp('(\\.\\d{' + scale + '})\\d+', 'g'),
      '$1'
    )
  }
  if (isOwe != null && isOwe === true && newVal.charAt(0) === '-') {
    oValue = '-' + oValue
  }
  if (max != null) {
    if (Number(oValue) > Number(max)) {
      oValue = oValue.substring(0, oValue.length - 1)
    }
  }
  return oValue
}

export function gUid() {
  let guid = ''
  let date = moment().format('YYMMDD')
  for (let i = 1; i <= 32; i++) {
    let n = Math.floor(Math.random() * 16.0).toString(16)
    guid += n
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      guid += ''
    }
  }
  guid = date + guid.substr(0, 12)
  return guid
}

// 导出excel
/**
 * @param {string}
 * @returns {Boolean}
 * exportUrl  请求路径
 * param 参数
 * callback 回调
 * 判断是否为空
 */
export function dateExportToExcel(exportUrl, param, callback) {
  let data = {}
  data.Params = param
  const timestamp = new Date().getTime()
  //  * Sign 签名(接口请求参数 + 时间戳 + key)进行MD5加密，key值使用登陆返回的Uid值
  data.ClientId = CHANNEL_ID
  data.Timestamp = timestamp
  const state = store.state || {}
  const userInfo = state.userInfo || {}
  if (userInfo.id) {
    if (data.Params) {
      data.Params.operateId = userInfo.id
      data.Params.operateName = userInfo.username
      data.Params.COMPANY_ID = userInfo.companyId //  分表查询用的
    }
    data.OperateId = userInfo.id
    data.Token = state.sysToken
    const temp = JSON.stringify(data.Params)
    const sign = md5(temp + timestamp + CHANNEL_ID + state.sysUid).toLowerCase()
    data.Sign = sign
  }
  const array = []
  for (const key in param) {
    const keyVal = param[key]
    array.push(`${key}=${keyVal}`)
  }
  let url =
    SERVER_BASE_URL +
    exportUrl +
    '?Params=' +
    JSON.stringify(param) +
    '&ClientId=' +
    data.ClientId +
    '&Timestamp=' +
    timestamp +
    '&OperateId=' +
    data.OperateId +
    '&Token=' +
    data.Token +
    '&Sign=' +
    data.Sign +
    '&' +
    array.join('&')
  // console.log(url)
  // debugger
  window.location.href = url
  callback()
}

export function fileUpload(param, servletUrl) {
  let data = {}
  // data.Params = {}
  data.Params = param
  const timestamp = new Date().getTime()
  //  * Sign 签名(接口请求参数 + 时间戳 + key)进行MD5加密，key值使用登陆返回的Uid值
  data.ClientId = CHANNEL_ID
  data.Timestamp = timestamp
  const state = store.state || {}
  const userInfo = state.userInfo || {}
  if (userInfo.id) {
    if (data.Params) {
      data.Params.operateId = userInfo.id
      data.Params.operateName = userInfo.username
      data.Params.COMPANY_ID = userInfo.companyId //  分表查询用的
    }
    data.OperateId = userInfo.id
    data.Token = state.sysToken
    const temp = JSON.stringify(data.Params)
    const sign = md5(temp + timestamp + CHANNEL_ID + state.sysUid).toLowerCase()
    data.Sign = sign
  }
  // let obj = {
  //   Params: param,
  //   ClientId: data.ClientId,
  //   timestamp: timestamp,
  //   OperateId: data.OperateId,
  //   Token: data.Token,
  //   Sign: data.Sign
  // }
  const array = []
  for (const key in param) {
    const keyVal = param[key]
    array.push(`${key}=${keyVal}`)
  }
  // let param2 = {}
  let url =
    SERVER_BASE_URL +
    servletUrl +
    '?Params=' +
    JSON.stringify(param) +
    '&ClientId=' +
    data.ClientId +
    '&Timestamp=' +
    timestamp +
    '&OperateId=' +
    data.OperateId +
    '&Token=' +
    data.Token +
    '&Sign=' +
    data.Sign +
    '&' +
    array.join('&')
  return url
}

// 下载二维码
/**
 * @param {string}
 * @returns {Boolean}
 * exportUrl  请求路径
 * param 参数
 * callback 回调
 * 判断是否为空
 */
export function downloadQrCode(downUrl, param, callback, type) {
  let data = {}
  data.Params = param
  const timestamp = new Date().getTime()
  //  * Sign 签名(接口请求参数 + 时间戳 + key)进行MD5加密，key值使用登陆返回的Uid值
  data.ClientId = CHANNEL_ID
  data.Timestamp = timestamp
  const state = store.state || {}
  const userInfo = state.userInfo || {}
  if (userInfo.id) {
    if (data.Params) {
      data.Params.operateId = userInfo.id
      data.Params.operateName = userInfo.username
      data.Params.COMPANY_ID = userInfo.companyId //  分表查询用的
    }
    data.OperateId = userInfo.id
    data.Token = state.sysToken
    const temp = JSON.stringify(data.Params)
    const sign = md5(temp + timestamp + CHANNEL_ID + state.sysUid).toLowerCase()
    data.Sign = sign
  }
  const array = []
  for (const key in param) {
    const keyVal = param[key]
    array.push(`${key}=${keyVal}`)
  }
  let url =
    downUrl +
    'Params=' +
    JSON.stringify(param) +
    '&ClientId=' +
    data.ClientId +
    '&Timestamp=' +
    timestamp +
    '&OperateId=' +
    data.OperateId +
    '&Token=' +
    data.Token +
    '&Sign=' +
    data.Sign +
    '&' +
    array.join('&')
  // console.log(url, '***********')
  if (type) {
    return url
  }
  window.location.href = url
  callback()
}

// 订单来源名称
/*
 * orderSrc 订单来源
 * channelId 渠道id
 */
export function getOrderSrcName(orderSrc, channelId) {
  var name = '--'
  switch (orderSrc) {
    case '1':
      name = '前台'
      break
    case '2':
      name = '微信'
      break
    case '3':
      name = '饿了么'
      break
    case '4':
      name = '美团'
      break
    case '5':
      name = '支付宝'
      break
    case '6':
      name = '微信扫码'
      break
    case '7':
      name = '支付宝扫码'
      break
    case '8':
      // if (channelId === '100124') {
      //   name = '自助买单'
      // } else {
      //   name = '快捷结算'
      // }
      name = '抽奖'
      break
    case '9':
      name = '兑换'
      break
    // case '10':
    //     name = '参与抽奖';
    //     break;
    // case '11':
    //     name = '分享有礼';
    //     break;
    // case '12':
    //     name = '拼手气红包';
    //     break;
    // case '13':
    //     name = '助力拆红包';
    //     break;
  }
  return name
}

// 使用类型(CZ:储值,FK:付款,KK:扣款,ZS:赠送,JFXF:积分消费,PJJFZJ:评价积分增加,DDZFJF:订单折返积分,TK:退款,TZ:调账,TZCZ:调账储值,TZKK:调账扣款,ZHHB:账户合并,JFDR:积分导入,ZFJYZ:折返经验值,SJ:升级,JJ:降级，QDHD:签到活动)
// 订单流水使用使用类型
export function getUserTypeName(userType) {
  let name = ''
  switch (userType) {
    case 'CZ':
      name = '储值'
      break
    case 'FK':
      name = '付款'
      break
    case 'KK':
      name = '扣款'
      break
    case 'ZS':
      name = '赠送'
      break
    case 'JFXF':
      name = '积分消费'
      break
    case 'PJJFZJ':
      name = '评价积分增加'
      break
    case 'DDZFJF':
      name = '订单折返积分'
      break
    case 'TK':
      name = '退款'
      break
    case 'TZ':
      name = '调账'
      break
    case 'TZCZ':
      name = '调账储值'
      break
    case 'TZKK':
      name = '调账扣款'
      break
    case 'ZHHB':
      name = '账户合并'
      break
    case 'JFDR':
      name = '积分导入'
      break
    case 'ZFJYZ':
      name = '折返经验值'
      break
    case 'SJ':
      name = '升级'
      break
    case 'JJ':
      name = '降级'
      break
    case 'QDHD':
      name = '签到活动'
      break
    case 'FX':
      name = '分销'
      break
    case 'HYRZDJF':
      name = '会员日折返积分'
      break
    case 'ZF':
      name = '作废'
      break
    case 'ZSJF':
      name = '赠送积分'
      break
    case 'ZSJYZ':
      name = '赠送经验值'
      break
  }
  return name
}

// 订单类别(1:购买商品,2:购买项目,3:购买预约,4:购买次卡,5:预约后购物,6:充值,7:购买营销卡,8:购买VIP卡,9:积分商城,10:快捷结算,11:兑换,12:电子券核销,13:兑换积分商品,14:兑换商城商品,15:积分换权益卡,16:积分换储值卡,17:积分换礼品卡,18:积分换券,19:次卡核验)
// 订单类别(0:注册[占位使用],1:购买商品,2:购买项目,3:购买预约,4:购买次卡,5:预约后购物,6:充值,7:购买营销卡,8:购买VIP卡,9:积分商城,
//   * 10:快捷结算,11:兑换(在收银端直接扣除积分),12:电子券核销,13:兑换积分商品,14:兑换商城商品,15:积分换权益卡,16:积分换储值卡,
//   * 17:积分换礼品卡,18:积分换券,19:次卡核验,20:拼团订单[作废],21:积分换次卡,22:供应商接单订单,23:供应商商品,24:核销码商品,25:服务类型(招聘[无支付]))
//   * 26:服务类型(一键下单服务[无支付]),27:服务类型(任务[无支付]),28:外供应商商品,29:外供应商接单订单[28的子单],30:批量补货订单)

// 订单类别(0:注册[占位使用],1:购买商品,2:购买项目,3:购买预约,4:购买次卡,5:预约后购物,6:充值,7:购买营销卡,8:购买VIP卡,9:积分商城,
//   * 10:快捷结算,11:兑换(在收银端直接扣除积分),12:电子券核销,13:兑换积分商品,14:兑换商城商品,15:积分换权益卡,16:积分换储值卡,
//   * 17:积分换礼品卡,18:积分换券,19:次卡核验,20:拼团订单[作废],21:积分换次卡,22:供应商接单订单,23:供应商商品,24:核销码商品,25:服务类型(招聘[无支付]))
//   * 26:服务类型(一键下单服务[无支付]),27:服务类型(任务[无支付]),28:外供应商商品,29:外供应商接单订单[28的子单],30:批量补货订单
//   * 31:购买返象生活卡；32：兑换霸王商品；33:核销霸王卡；34:返象生活门店付款；35:付款成为分销商;36:付款成为高级分销商
//   * 40
export function getOrderCategoryName(orderCategory) {
  var name = '--'
  switch (orderCategory) {
    case '1':
      name = '购买商品'
      break
    case '2':
      name = '购买项目'
      break
    case '3':
      name = '购买预约'
      break
    case '4':
      name = '购买次卡'
      break
    case '5':
      name = '预约后购物'
      break
    case '6':
      name = '充值'
      break
    case '7':
      name = '购买礼品卡'
      break
    case '8':
      name = '购买权益卡'
      break
    case '9':
      name = '积分商城'
      break
    case '10':
      name = '快捷结算'
      break
    case '11':
      name = '兑换'
      break
    case '12':
      name = '电子券核销'
      break
    case '13':
      name = '兑换积分商品'
      break
    case '14':
      name = '兑换商城商品'
      break
    case '15':
      name = '积分换权益卡'
      break
    case '16':
      name = '积分换储值卡'
      break
    case '17':
      name = '积分换礼品卡'
      break
    case '18':
      name = '积分换券'
      break
    case '19':
      name = '次卡核验'
      break
    case '21':
      name = '积分换次卡'
      break
    case '22':
      name = '供应商接单订单'
      break
    case '23':
      name = '供应商商品'
      break
    case '24':
      name = '核销码商品'
      break
    case '25':
      name = '服务类型'
      break
    case '26':
      name = '一键下单'
      break
    case '27':
      name = '服务类型[任务]'
      break
    case '28':
      name = '外供应商商品'
      break
    case '29':
      name = '外供应商接单订单'
      break
    case '30':
      name = '一键补货'
      break
    case '38':
      name = '外部码导入商品'
      break
    case '101':
      name = '购买商品'
      break
    case '102':
      name = '代取快递'
      break
    case '103':
      name = '跑腿任务'
      break
    case '104':
      name = '高校核销码商品'
      break
    case '41':
      name = '霸王餐商户充值'
      break
    case '42':
      name = '霸王餐用户订单'
      break
  }
  return name
}

// 业务类型(1:订单支付,2:清账支付,3:充值支付,4:退款支付,5:调账,6:快捷结算支付,7:结算退款充值,8:兑换,9:积分商城兑换,10:参与抽奖,11.分享有礼,12:拼手气红包,13:助力拆红包
export function getBusinessTypeName(businessType) {
  var name = '--'
  switch (businessType) {
    case '1':
      name = '订单支付'
      break
    case '2':
      name = '清账支付'
      break
    case '3':
      name = '充值支付'
      break
    case '4':
      name = '退款支付'
      break
    case '5':
      name = '调账'
      break
    case '6':
      name = '快捷结算支付'
      break
    case '7':
      name = '结算退款充值'
      break
    case '8':
      name = '兑换'
      break
    case '9':
      name = '积分商城兑换'
      break
    case '10':
      name = '参与抽奖'
      break
    case '11':
      name = '分享有礼'
      break
    case '12':
      name = '拼手气红包'
      break
    case '13':
      name = '助力拆红包'
      break
  }
  return name
}
/**  **************** xsd start *****************  **/
// 生成map对象
export function generatorMap(list, keyId, isArray) {
  let mapList = {}
  list.forEach(it => {
    const key = it[keyId]
    if (!mapList[key]) {
      mapList[key] = isArray ? [] : {}
    }
    if (isArray) {
      mapList[key].push(it)
    } else {
      mapList[key] = it
    }
  })
  return mapList
}
// -1 转成 ''
export function shiftOneToEmpty(val) {
  return Number(val) === -1 ? '' : val
}
// '' 装 -1
export function shiftEmptyToOne(val) {
  return !Number(val) ? -1 : val
}
export function getValuesByArray(arr1, arr2) {
  let arr = []
  for (let i = 0; i < arr1.length; i++) {
    let v1 = arr1[i]
    for (let j = 0; j < arr2.length; j++) {
      let v2 = arr2[j]
      let value = v1 + '#' + v2
      arr.push(value)
    }
  }
  return arr
}

export function getArrayByArrays(arrays) {
  let arr = ['']
  for (let i = 0; i < arrays.length; i++) {
    arr = getValuesByArray(arr, arrays[i])
  }
  return arr
}
// 校验时间是否重叠 list = [{start: '', end: ''}]   false: 没有重叠  true: 有重叠
export function checkIsOverLap(list, start, end) {
  if (!start || !end || !list || !list.length) return false
  const nowDate = moment().format('YYYY-MM-DD')
  const tomorrowDate = moment()
    .add(1, 'day')
    .format('YYYY-MM-DD')
  const startDateTime = nowDate + ' ' + start
  let endDateTime = nowDate + ' ' + end
  let isNext = startDateTime >= endDateTime // 是否隔天
  // 判断是否隔天
  if (isNext) {
    // 05-24 06:35:00
    endDateTime = tomorrowDate + ' ' + end
  }
  const startTimeStamp = moment(startDateTime).valueOf()
  const endTimeStamp = moment(endDateTime).valueOf()
  let isOverLap = false
  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    let _sStamp = moment(nowDate + ' ' + item.start).valueOf()
    let _eStamp = moment(nowDate + ' ' + item.end).valueOf()
    const isItemNext = _sStamp >= _eStamp // 判断是否隔天
    if (isItemNext) {
      _eStamp = moment(tomorrowDate + ' ' + item.end).valueOf()
      // isOverLap = true
    }
    // 开始时间
    if (startTimeStamp >= _sStamp && startTimeStamp <= _eStamp) {
      isOverLap = true
    }
    // 没有跨天
    if (!isNext) {
      // 结束时间
      if (endTimeStamp >= _sStamp && endTimeStamp <= _eStamp) {
        isOverLap = true
      }
      // 包裹时间
      if (startTimeStamp < _sStamp && endTimeStamp > _eStamp) {
        isOverLap = true
      }
    } else {
      // 如果都是跨天
      if (isNext && isItemNext) {
        if (endTimeStamp <= _eStamp) {
          isOverLap = true
        }
      } else {
        // 条目的时间没跨天，选择的时间有跨天
        _sStamp = moment(tomorrowDate + ' ' + item.start).valueOf()
        _eStamp = moment(tomorrowDate + ' ' + item.end).valueOf()
        // if ()
        isOverLap = endTimeStamp > _sStamp || endTimeStamp >= _eStamp
      }
    }
    if (isOverLap) break
  }
  return isOverLap
}

/**  **************** xsd end *****************  **/
//   export function validateInNum(filed, precision, scale, isOwe, max) {
//     var val = this.$data[filed]
//     this.$data[filed] = this.validateNum(val, precision, scale, isOwe, max)
//   }
export function jqueryAjax(params) {
  let array = []
  for (const key in params) {
    const keyVal = params[key]
    if (typeof keyVal !== 'object') {
      array.push(`${key}=${keyVal}`)
    } else {
      array.push(`${key}=${encodeURIComponent(JSON.stringify(keyVal))}`)
    }
  }
  let temp = array.join('&')
  return new Promise(resolve => {
    $.ajax({
      url: 'https://dyp.hyunst.com/dyp_ht/special_callApi.do',
      type: 'POST',
      method: 'post',
      data: temp,
      dataType: 'json',
      success: function(data) {
        return resolve(data)
      },
      error: function(data) {
        //
      }
    })
  })
}

// 函数拷贝
export function copyObj(obj) {
  // 变量先置空
  let newobj = null
  // 判断是否需要继续进行递归
  if (typeof obj === 'object' && obj !== null) {
    newobj = obj instanceof Array ? [] : {}
    // 进行下一层递归克隆
    for (var i in obj) {
      newobj[i] = copyObj(obj[i])
    }
    // 如果不是对象直接赋值
  } else newobj = obj
  return newobj
}

export function getTime(time) {
  // 转换为式分秒
  let h = parseInt((time / 60 / 60) % 24)
  h = h < 10 ? '0' + h : h
  let m = parseInt((time / 60) % 60)
  m = m < 10 ? '0' + m : m
  let s = parseInt(time % 60)
  s = s < 10 ? '0' + s : s
  // 作为返回值返回
  return [h, m, s]
}
